var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29866 8.44625L7.50671 3.2382L12.7148 8.44625C13.2383 8.96974 14.0839 8.96974 14.6074 8.44625C15.1309 7.92276 15.1309 7.07712 14.6074 6.55363L8.44631 0.39256C7.92282 -0.13093 7.07718 -0.13093 6.55369 0.39256L0.392617 6.55363C-0.130872 7.07712 -0.130872 7.92276 0.392617 8.44625C0.916107 8.95632 1.77517 8.96974 2.29866 8.44625Z",
    fill: "#7F40A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.d63bf6bb4322be1bd654e0b6642eccb4.svg";
export { ForwardRef as ReactComponent };